module.exports = __webpack_public_path__ + "static/media/imagemColetoresHospital3.f99f2355.png";